import React from "react";
import {
    Announcement,
    Update,
    Info,
    Warning,
    Chat,
    Notifications, Build,
} from "@material-ui/icons";

export const ICON_MAP: Record<string, JSX.Element> = {
    announcement: <Announcement />,
    update: <Update />,
    info: <Info />,
    warning: <Warning />,
    chat: <Chat />,
    notifications: <Notifications />,
    build: <Build />,
};

export const ICON_OPTIONS = Object.keys(ICON_MAP);
